import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { MenuIcon, XIcon, ChevronDownIcon } from 'lucide-react';
export function Header() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [procurementOpen, setProcurementOpen] = useState(false);
  return <header className="bg-white border-b border-gray-border sticky top-0 z-50" data-id="element-258" data-mp="19qnh6yvektnd">
      <div className="max-w-7xl mx-auto px-4" data-id="element-259" data-mp="19okuanpjrgmv">
        <div className="flex items-center justify-between h-20" data-id="element-260" data-mp="m1utfpoxps3u">
          <Link to="/" className="flex items-center gap-3" data-id="element-261" data-mp="hzho32e3nw7l">
            <img src="https://cdn.magicpatterns.com/uploads/dUQRpLPA28c7QtfR6xGyBP/Logo.png" alt="African Union Commission" className="w-12 h-12 object-contain" data-id="element-262" data-mp="i12jsvc5hl71" />
            <div data-id="element-263" data-mp="qy32qmggar33">
              <div className="font-serif text-xl font-bold" style={{
              color: '#8B1A2C'
            }} data-id="element-264" data-mp="3a1znt21k2v2">
                African Union
              </div>
              <div className="text-sm text-gray-600" data-id="element-265" data-mp="6wgknb8dl6wq">Commission</div>
            </div>
          </Link>

          <nav className="hidden lg:flex items-center gap-8" data-id="element-266" data-mp="btzwy5lij9m1">
            <Link to="/" className="text-charcoal hover:text-au-green transition-colors font-medium" data-id="element-267" data-mp="glhz2wz9vg8l">
              Home
            </Link>
            <Link to="/about" className="text-charcoal hover:text-au-green transition-colors font-medium" data-id="element-268" data-mp="lmnrsusxn3i4">
              About
            </Link>
            <Link to="/projects" className="text-charcoal hover:text-au-green transition-colors font-medium" data-id="element-269" data-mp="3p1jtn71gq32f">
              Projects
            </Link>
            <Link to="/bids" className="text-charcoal hover:text-au-green transition-colors font-medium" data-id="element-270" data-mp="1y58gtulykbc">
              Bids & Tenders
            </Link>

            <div className="relative" onMouseEnter={() => setProcurementOpen(true)} onMouseLeave={() => setProcurementOpen(false)} data-id="element-271" data-mp="1da61wm2f2wxf">
              <button className="flex items-center gap-1 text-charcoal hover:text-au-green transition-colors font-medium py-2" data-id="element-272" data-mp="35ciij410b092">
                Procurement
                <ChevronDownIcon size={16} data-id="element-273" data-mp="3edyrr8g34wbp" />
              </button>

              {procurementOpen && <div className="absolute top-full left-0 pt-2 w-56 z-50" data-id="element-274" data-mp="2qo4ggvbezftk">
                  <div className="bg-white rounded-lg shadow-lg border border-gray-border py-2" data-id="element-275" data-mp="2qm1hvmw74ed8">
                    <Link to="/procurement/annual-plan" className="block px-4 py-2 hover:bg-au-green-light transition-colors" data-id="element-276" data-mp="2mkzgp0ipxs8m">
                      Annual Plan
                    </Link>
                    <Link to="/procurement/contract-awards" className="block px-4 py-2 hover:bg-au-green-light transition-colors" data-id="element-277" data-mp="27wux7ubudcos">
                      Contract Awards
                    </Link>
                    <Link to="/procurement/unsuccessful-bids" className="block px-4 py-2 hover:bg-au-green-light transition-colors" data-id="element-278" data-mp="n7he0o5amzik">
                      Unsuccessful Bids
                    </Link>
                    <Link to="/procurement/manual" className="block px-4 py-2 hover:bg-au-green-light transition-colors" data-id="element-279" data-mp="effh2zufo1d1">
                      Procurement Manual
                    </Link>
                    <Link to="/procurement/supplier-registration" className="block px-4 py-2 hover:bg-au-green-light transition-colors" data-id="element-280" data-mp="s73ud6gf4vvl">
                      Expression of Interest (EOI)
                    </Link>
                  </div>
                </div>}
            </div>

            <Link to="/contact" className="text-charcoal hover:text-au-green transition-colors font-medium" data-id="element-281" data-mp="3httbdjaup0a4">
              Contact
            </Link>
          </nav>

          <button className="lg:hidden" onClick={() => setMobileMenuOpen(!mobileMenuOpen)} data-id="element-282" data-mp="3sczs9gdhzn74">
            {mobileMenuOpen ? <XIcon size={24} data-id="element-283" data-mp="3jf7eignfcnlu" /> : <MenuIcon size={24} data-id="element-284" data-mp="3jfpki4zw2g6y" />}
          </button>
        </div>

        {mobileMenuOpen && <nav className="lg:hidden py-4 border-t border-gray-border" data-id="element-285" data-mp="jyhh35s9frja">
            <Link to="/" className="block py-2 hover:text-au-green transition-colors" data-id="element-286" data-mp="fx60tqva0inr">
              Home
            </Link>
            <Link to="/about" className="block py-2 hover:text-au-green transition-colors" data-id="element-287" data-mp="5z8e57t2etx9">
              About
            </Link>
            <Link to="/projects" className="block py-2 hover:text-au-green transition-colors" data-id="element-288" data-mp="2vpv81ojhetn8">
              Projects
            </Link>
            <Link to="/bids" className="block py-2 hover:text-au-green transition-colors" data-id="element-289" data-mp="2gmv34lw43kmu">
              Bids & Tenders
            </Link>
            <div className="py-2" data-id="element-290" data-mp="2qjg8j8c1mxr7">
              <div className="font-medium mb-2" data-id="element-291" data-mp="2qiexv4yxwda0">Procurement</div>
              <Link to="/procurement/annual-plan" className="block py-1 pl-4 hover:text-au-green transition-colors" data-id="element-292" data-mp="2vaoo6m3yvfct">
                Annual Plan
              </Link>
              <Link to="/procurement/contract-awards" className="block py-1 pl-4 hover:text-au-green transition-colors" data-id="element-293" data-mp="349ti1f4l2kin">
                Contract Awards
              </Link>
              <Link to="/procurement/unsuccessful-bids" className="block py-1 pl-4 hover:text-au-green transition-colors" data-id="element-294" data-mp="3e8j13b87ub0h">
                Unsuccessful Bids
              </Link>
              <Link to="/procurement/manual" className="block py-1 pl-4 hover:text-au-green transition-colors" data-id="element-295" data-mp="1buljr3cg8vfs">
                Procurement Manual
              </Link>
              <Link to="/procurement/supplier-registration" className="block py-1 pl-4 hover:text-au-green transition-colors" data-id="element-296" data-mp="1lshw1yh4hwfh">
                Expression of Interest (EOI)
              </Link>
            </div>
            <Link to="/contact" className="block py-2 hover:text-au-green transition-colors" data-id="element-297" data-mp="1urmt10d1dhpj">
              Contact
            </Link>
          </nav>}
      </div>
    </header>;
}